module.exports = __webpack_public_path__ + "img/image3.b09e200d.png";